import axios from 'axios';

export default {
	get(url, options) {
		const result = { response: {}, error: null, loading: true };
		return axios
			.get(url, options)
			.then((response) => {
				result.response = response;
				return result;
			})
			.catch((error) => {
				result.error = error;
				return result;
			})
			.finally(() => {
				result.loading = false;
			});
	},
};
